import { render, staticRenderFns } from "./reviewListIndex.pug?vue&type=template&id=13e4738c&scoped=true&lang=pug&"
import script from "./reviewListIndex.ts?vue&type=script&lang=ts&"
export * from "./reviewListIndex.ts?vue&type=script&lang=ts&"
import style0 from "./reviewListIndex.scss?vue&type=style&index=0&id=13e4738c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e4738c",
  null
  
)

export default component.exports